<template>
  <div class="counter" :class="{ 'counter--multi': isMultiRoom }">
    <div class="counter__body">
      <!-- MODO ARREGLO (Múltiples habitaciones) -->
      <template v-if="isMultiRoom">
        <div v-for="(room, rIdx) in model" :key="`room_${rIdx}`" class="counter__room">
          <div class="counter__room-header" v-if="props.product == 'P'">
            <p class="counter__title font-16 font-strong">
              {{ __('booker.room') }} {{ rIdx + 1 }}
            </p>
            <button v-if="model.length > 1 && rIdx > 0" type="button" class="btnTertiary"
              @click="removeRoom(rIdx, $event)">
              {{ __('booker.remove') }}
            </button>
          </div>
          <ul class="counter__list">
            <li v-for="field in getRoomFields(room)" :key="field.key" class="counter__item-wrapper">
              <div class="counter__item">
                <div class="counter__info">
                  <p class="counter__title font-16 font-400 font-strong">{{ field.label }}</p>
                  <span class="counter__desc font-14 font-subtle">{{ field.description }}</span>
                </div>
                <div class="counter__controls">
                  <button class="counter__btn counter__btn--minus btnIcon btnIcon--md" type="button"
                    :aria-label="__('booker.decrement') + ' ' + field.label"
                    :disabled="!canDecrementField(field.key, rIdx)" @click="decrement(rIdx, field.key)">
                    <span class="icon icons-remove font-20"></span>
                  </button>
                  <span class="counter__value">
                    {{ Array.isArray(room[field.key]) ? room[field.key].length : room[field.key] }}
                  </span>
                  <button class="counter__btn counter__btn--plus btnIcon btnIcon--md" type="button"
                    :aria-label="__('booker.increment') + ' ' + field.label" :disabled="!canIncrementField(field.key)"
                    @click="increment(rIdx, field.key)">
                    <span class="icon icons-add font-20"></span>
                  </button>
                </div>
              </div>
              <!-- Edades de niños mode multi -->
              <div v-if="field.key === 'children' && Array.isArray(room.children) && room.children.length > 0" class="children-ages">
                <div v-for="(child, cIdx) in room.children" :key="`c_${rIdx}_${cIdx}`"
                  class="modal-paxes_content_option-minors">
                  <label>{{ __('booker.age_minor') }} {{ cIdx + 1 }}</label>
                  <select class="form-control" v-model="room.children[cIdx].year">
                    <option :value="null">{{ __('booker.childred_age') }}</option>
                    <option v-for="age in years" :key="age" :value="age">{{ formatChildAge(age) }}</option>
                  </select>
                  <small class="text-danger" v-if="submitted && room.children[cIdx].year === null">{{
                    __('booker.error_children')
                  }}</small>
                </div>
              </div>
            </li>
          </ul>

          <!-- Alerta a nivel de cada habitación individual -->
          <div v-if="isRoomDense(room) && props.product == 'P'" class="counter__alert counter__alert--room">
            <span class="icon icons-info font-20" style="margin-right: 8px;"></span>
            <span>{{ __('booker.max_paxes') }}</span>
          </div>
        </div>
      </template>

      <!-- MODO OBJETO (Simple) -->
      <template v-else>
        <ul class="counter__list">
          <li v-for="field in activeFields" :key="field.key" class="counter__item-wrapper">
            <div class="counter__item">
              <div class="counter__info">
                <p class="counter__title font-16 font-400 font-strong">{{ field.label }}</p>
                <span class="counter__desc font-14 font-subtle">{{ field.description }}</span>
              </div>
              <div class="counter__controls">
                <button class="counter__btn counter__btn--minus btnIcon btnIcon--md" type="button"
                  :aria-label="__('booker.decrement') + ' ' + field.label" :disabled="!canDecrementField(field.key)"
                  @click="decrementSingle(field.key)">
                  <span class="icon icons-remove font-20"></span>
                </button>
                <span class="counter__value">
                  {{ Array.isArray(model[field.key]) ? model[field.key].length : model[field.key] }}
                </span>
                <button class="counter__btn counter__btn--plus btnIcon btnIcon--md" type="button"
                  :aria-label="__('booker.increment') + ' ' + field.label" :disabled="!canIncrementField(field.key)"
                  @click="incrementSingle(field.key)">
                  <span class="icon icons-add font-20"></span>
                </button>
              </div>
            </div>
            <!-- Niños mode simple -->
            <div v-if="field.key === 'children' && Array.isArray(model.children) && model.children.length > 0" class="children-ages">
              <div v-for="(child, cIdx) in model.children" :key="`c_${cIdx}`" class="modal-paxes_content_option-minors">
                <label>{{ __('booker.age_minor') }} {{ cIdx + 1 }}</label>
                <select class="form-control" v-model="model.children[cIdx].year">
                  <option :value="null">{{ __('booker.childred_age') }}</option>
                  <option v-for="age in years" :key="age" :value="age">{{ formatChildAge(age) }}</option>
                </select>
                <small class="text-danger" v-if="submitted && model.children[cIdx].year === null">{{
                  __('booker.error_children')
                }}</small>
              </div>
            </div>
          </li>
        </ul>
      </template>
    </div>
    <!-- ALERTAS GLOBALES -->
    <div v-if="showMaxPaxesWarning && props.product != 'H'" class="counter__alert counter__alert--global">
      <span class="icon icons-info font-20" style="margin-right: 8px;"></span>
      <span>{{ __('booker.max_paxes_global', [props.settingPaxes.totalPaxes]) }}</span>
    </div>
    <!-- REGLA INFANTES - ADULTOS (Vuelos) -->
    <div v-if="showInfantAdultAlert" class="counter__alert counter__alert--error counter__alert--global">
      <span class="icon icons-info font-20" style="margin-right: 8px;"></span>
      <span>{{ __("booker.notificationKids") }}</span>
    </div>

    <!-- ACCIONES -->
    <div class="counter__actions">
      <button v-if="isMultiRoom && props.product == 'P'" class="counter__action btnTertiary btnTertiary--md" @click="addRoom"
        type="button" :disabled="isAddRoomDisabled">
        {{ __('booker.add_room') }}
      </button>
      <button v-else class="counter__action btnTertiary btnTertiary--md" @click="onCancel" type="button">
        {{ __('booker.cancel') }}
      </button>

      <button class="counter__action btnPrimary" @click="onApply" type="button" :disabled="showInfantAdultAlert">
        {{ __('booker.apply') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, getCurrentInstance, onMounted } from 'vue'

const submitted = ref(false)

const { proxy } = getCurrentInstance()
const __ = proxy.__

const props = defineProps({
  counts: [Object, Array],
  settingPaxes: Object,
  product: String
})

const emit = defineEmits(['change', 'apply', 'cancel'])

const clone = (v) => JSON.parse(JSON.stringify(v))

/* ======================================
   FIELD CONFIG
====================================== */

const fieldConfig = {
  adults: {
    label: __('booker.adults'),
    description: props.product == "F" ? __('booker.flight_adults_subtle') :  __('booker.adults_subtle'),
    default: 1,
    min: () => props.settingPaxes.minAdults,
    max: () => props.settingPaxes.maxAdults
  },
  children: {
    label: __('booker.childrens'),
    description: __('booker.childrens_subtle', [props.settingPaxes.maxAge]),
    default: [],
    min: () => 0,
    max: () => props.settingPaxes.maxChildren
  },
  infants: {
    label: __('booker.infants'),
    description: __('booker.infants_subtle'),
    default: 0,
    min: () => 0,
    max: () => props.settingPaxes.maxInfants
  },
  rooms: {
    label: __('booker.rooms'),
    // description: __('booker.rooms_subtle'),
    default: 1,
    min: () => 1,
    max: () => props.settingPaxes.rooms
  }
}

/* ======================================
   MODE
====================================== */

const isMultiRoom = computed(() => Array.isArray(props.counts))

/* ======================================
   MODEL
====================================== */

const model = ref(
  isMultiRoom.value
    ? clone(props.counts)
    : clone(props.counts || {})
)

const createRoom = () => {
  let initialChildren = []
  if (isMultiRoom.value && model.value.length > 0) {
    initialChildren = Array.isArray(model.value[0].children) ? [] : 0
  }

  const newItem = {
    adults: props.settingPaxes.minAdults || 1,
    children: initialChildren
  }
  // Copiar cualquier otro campo presente en la primera habitación (ej. pets)
  if (isMultiRoom.value && model.value.length > 0) {
    Object.keys(model.value[0]).forEach(key => {
      if (!['adults', 'children'].includes(key)) newItem[key] = 0
    })
  }
  return newItem
}

let snapshot = clone(model.value)

/* ======================================
   UI HELPERS
====================================== */

const activeFields = computed(() => {
  if (isMultiRoom.value) return []
  return Object.keys(model.value)
    .filter(key => key in fieldConfig)
    .map(key => ({
      key,
      ...fieldConfig[key]
    }))
})

const getRoomFields = (room) => {
  return Object.keys(room)
    .filter(key => key in fieldConfig)
    .map(key => ({
      key,
      ...fieldConfig[key]
    }))
}

const years = computed(() => {
  const arr = []
  for (let i = props.settingPaxes.minAge; i <= props.settingPaxes.maxAge; i++) {
    arr.push(i)
  }
  return arr
})

const formatChildAge = (year) => {
  if (props.product != 'H' && year === 1) return __('booker.minors_23')
  if (year === 1) return `1 ${__('booker.year')}`
  return `${year} ${__('booker.years')}`
}

/* ======================================
   LIMIT HELPERS
====================================== */

const getTotalPaxes = () => {
  if (isMultiRoom.value) {
    return model.value.reduce((sum, room) => sum + (room.adults || 0) + (Array.isArray(room.children) ? room.children.length : (room.children || 0)), 0)
  }
  return (model.value.adults || 0) + (Array.isArray(model.value.children) ? model.value.children.length : (model.value.children || 0))
}

const getTotalCount = (key) => {
  if (isMultiRoom.value) {
    return model.value.reduce((sum, room) => {
      const val = room[key]
      return sum + (Array.isArray(val) ? val.length : (val || 0))
    }, 0)
  }
  const val = model.value[key]
  return Array.isArray(val) ? val.length : (val || 0)
}

const canIncrementField = (key) => {
  const config = fieldConfig[key]
  if (!config) return true

  if (getTotalCount(key) >= config.max()) {
    return false
  }

  if (['adults', 'children'].includes(key) && props.settingPaxes.totalPaxes) {
    if (getTotalPaxes() >= props.settingPaxes.totalPaxes) {
      return false
    }
  }
  return true
}

const canDecrementField = (key, rIndex = null) => {
  const config = fieldConfig[key]
  if (!config) return true

  const target = rIndex !== null ? model.value[rIndex] : model.value
  const val = target[key]
  const count = Array.isArray(val) ? val.length : (val || 0)

  return count > config.min()
}

const isAddRoomDisabled = computed(() => {
  if (!isMultiRoom.value) return false
  if (model.value.length >= props.settingPaxes.rooms) return true
  if (props.settingPaxes.totalPaxes && (getTotalPaxes() + (props.settingPaxes.minAdults || 1)) > props.settingPaxes.totalPaxes) return true
  return false
})

const showMaxPaxesWarning = computed(() => {
  if (!props.settingPaxes.totalPaxes) return false
  return getTotalPaxes() >= props.settingPaxes.totalPaxes
})

const isRoomDense = (room) => {
  if (!room) return false
  const ad = room.adults || 0
  const ch = Array.isArray(room.children) ? room.children.length : (room.children || 0)
  return (ad + ch) > 5
}

/* ======================================
   SINGLE MODE METHODS
====================================== */

const incrementSingle = (key) => {
  if (!canIncrementField(key)) return
  if (Array.isArray(model.value[key])) {
    model.value[key].push({ year: null })
    submitted.value = false
  } else {
    model.value[key]++
  }
}

const decrementSingle = (key) => {
  if (!canDecrementField(key)) return
  if (Array.isArray(model.value[key])) {
    model.value[key].pop()
  } else {
    model.value[key]--
  }
}

/* ======================================
   MULTI ROOM METHODS
====================================== */

const addRoom = () => {
  if (!isAddRoomDisabled.value) model.value.push(createRoom())
}

const removeRoom = (index, event) => {
  event.stopPropagation()
  if (model.value.length > 1) model.value.splice(index, 1)
}

const increment = (rIndex, key) => {
  if (!canIncrementField(key)) return
  const room = model.value[rIndex]
  if (Array.isArray(room[key])) {
    room[key].push({ year: null })
    submitted.value = false
  } else {
    room[key]++
  }
}

const decrement = (rIndex, key) => {
  if (!canDecrementField(key, rIndex)) return
  const room = model.value[rIndex]
  if (Array.isArray(room[key])) {
    room[key].pop()
  } else {
    room[key]--
  }
}

/* ======================================
   ACTIONS
====================================== */

/* ======================================
   INFANT/ADULT RULE (Flights)
====================================== */

const showInfantAdultAlert = computed(() => {
  // Aplica para vuelos (V) y paquetes (P)
  if (!['F', 'P'].includes(props.product)) return false

  const adults = isMultiRoom.value
    ? model.value.reduce((sum, r) => sum + (r.adults || 0), 0)
    : (model.value.adults || 0)

  // Infantes son los menores con año 1 (0-23 meses)
  const infants = isMultiRoom.value
    ? model.value.reduce((sum, r) => sum + (Array.isArray(r.children) ? r.children.filter(c => c.year === 1).length : 0), 0)
    : (Array.isArray(model.value.children) ? model.value.children.filter(c => c.year === 1).length : 0)

  return infants > adults
})



const canApply = computed(() => {
  const allChildrenAgesSelected = isMultiRoom.value
    ? model.value.every(room => !Array.isArray(room.children) || room.children.every(c => c.year !== null))
    : (!Array.isArray(model.value.children) || model.value.children.every(c => c.year !== null))

  if (!allChildrenAgesSelected) return false

  if (showInfantAdultAlert.value) return false

  return true
})

const onApply = () => {
  submitted.value = true
  if (!canApply.value) return

  const payload = clone(model.value)
  snapshot = clone(model.value)
  emit('change', payload)
  emit('apply', payload)
}

const onCancel = () => {
  submitted.value = false
  const restored = clone(snapshot)
  if (isMultiRoom.value) {
    model.value.length = 0
    model.value.push(...restored)
  } else {
    Object.assign(model.value, restored)
  }
  emit('cancel')
}

/* ======================================
   WATCH SYNC
====================================== */

watch(() => props.counts, (val) => {
  if (!val) return
  const fresh = clone(val)
  if (Array.isArray(fresh) && Array.isArray(model.value)) {
    model.value.length = 0
    model.value.push(...fresh)
  } else {
    Object.assign(model.value, fresh)
  }
  snapshot = clone(model.value)
  submitted.value = false
}, { deep: true })

onMounted(() => {
  snapshot = clone(model.value)
})
</script>

<style scoped lang="scss">
.counter {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
  margin-bottom: calc(var(--space-4) * 20);

  @media (min-width: 768px) {
    width: 290px;
    margin-bottom: 0px;
  }

  &--multi {
    .counter__body {
      overflow-y: auto;
    }
  }

  p {
    margin: 0px;
  }

  .icon {
    display: flex;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: var(--space-20);
    padding: 0px;
    list-style: none;
    margin-bottom: 0px;

    @media (min-width: 480px) {
      padding: var(--space-20);
    }
  }

  &__room {
    padding: var(--space-16);
    border-bottom: 1px solid var(--border-subtle);

    &:last-child {
      border-bottom: none;
    }

    .counter__list {
      padding: 0;
    }
  }

  &__room-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--space-12);
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-12);
  }

  &__controls {
    display: flex;
    align-items: center;
    gap: 0px;
  }

  &__btn {
    width: 40px;
    height: 40px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__value {
    width: 40px;
    display: flex;
    justify-content: center;
  }

  &__actions {
    position: fixed;
    bottom: 0px;
    width: 100%;
    left: 0px;
    display: flex;
    align-items: center;
    gap: var(--space-16);
    padding: var(--space-16);
    background-color: var(--bg-base);
    border-top: 1px solid var(--border-subtle);

    @media (min-width: 768px) {
      position: unset;
      padding: var(--space-20);
      gap: var(--space-32);
    }
  }

  &__action {
    flex: 1;
    white-space: nowrap;
  }
}

.children-ages {
  margin-top: var(--space-12);
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-8);

}

.modal-paxes_content_option-minors {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-4);

  label {
    font-size: 12px;
    color: var(--text-subtle);
    white-space: nowrap;
    margin: 0px;
    flex: 1;
  }

  select {
    width: 100px;
    flex: 1;
  }

  select,
  label {
    cursor: pointer;
  }

  small {
    width: 100%;
    text-align: right;
  }
}

.counter__alert {
  display: flex;
  align-items: flex-start;
  background-color: var(--bg-warning-subtle);
  color: var(--text-warning);
  font-size: 14px;
  border-radius: var(--space-4);
  border-left: 4px solid var(--border-warning);
  line-height: 1.4;
  padding: var(--space-12) var(--space-16);

  &--global {
    margin: var(--space-16);
    margin-bottom: auto;

    @media (min-width: 480px) {
      margin: var(--space-16);
    }
  }

  &--room {
    margin-top: var(--space-16);
  }

  &--error {
    background-color: rgb(149, 0, 0);
    color: #FFFFFF;
    border-left: none;
    font-weight: 500;
    border-radius: var(--space-8);
  }
}
</style>
